async function addToCartOnSelect(variant) {

    let quickAddForm = variant.closest('form')

    let variantId = variant.dataset.variantProperty
    let propertyInfo = variant.dataset.dateProperty
    let originalPrice = variant.dataset.originalPrice
    let discount = variant.dataset.ondemandDiscount
    if(propertyInfo === undefined) {
      propertyInfo = 'Shipping Ready'
    }

    if(propertyInfo !== 'Shipping Ready') {
      let preorderInput = document.createElement('input')
      preorderInput.type = 'hidden'
      preorderInput.id = 'pre_order_shipping_starts_at'
      preorderInput.name = propertyInfo
      preorderInput.value = 1
      quickAddForm.appendChild(preorderInput)
    } else {
      let readyInput = document.createElement('input')
      readyInput.type = 'hidden'
      readyInput.id = 'pre_order_shipping_ready'
      readyInput.name = 'Shipping Ready'
      readyInput.value = 1
      quickAddForm.appendChild(readyInput)
    }
    if(originalPrice) {
      let priceInput = document.createElement('input')
      priceInput.type = 'hidden'
      priceInput.id = 'base_price'
      priceInput.name = 'Original price'
      priceInput.value = originalPrice
      quickAddForm.appendChild(priceInput)
    }
    if(discount) {
      let discountInput = document.createElement('input')
      discountInput.type = 'hidden'
      discountInput.id = 'discount_percentage'
      discountInput.name = 'On-demand reward'
      discountInput.value = discount
      quickAddForm.appendChild(discountInput)
    }

    let bagItem = {
        id: Number(variantId),
        quantity: 1,
        properties: {
            [propertyInfo] : 1,
            discount_percentage: discount,
            base_price: originalPrice
        }
    }

    let items = [bagItem]

    // Si en esta superficie hay un charm seleccionado, lo emparejamos con la bag
    // via _parent_bag_id/_bag_id (misma logica que ff-bags-cross-sell) para que el
    // add del selector de tallas tambien meta el charm y no llegue huerfano al carrito.
    let charmSelection = getSelectedCharmItems(variant)
    if (charmSelection) {
        let bagId = 'bag-' + Date.now()
        bagItem.properties._bag_id = bagId
        if (charmSelection.isMulti) bagItem.properties._multi_charm = '1'
        charmSelection.items.forEach((charm) => { charm.properties._parent_bag_id = bagId })
        items.unshift(...charmSelection.items)
    }

    await addToCartCustom({ items })

    quickAddForm.closest('.quick-add-modal').removeAttribute('open')
    
    setTimeout( function() {
      document.querySelector('.loading_spinner__overlay').classList.remove('is-visible')
      openCartDrawer();
    }, 300)
}

function getSelectedCharmItems(variant) {
  // Query document-wide: la talla se elige dentro del <quick-add-modal>, un subarbol
  // separado de la section donde vive el charm selector, asi que no podemos scopear al
  // modal. Excluimos selectores anidados en un modal para no coger el charm de otro
  // producto (p.ej. un quick-add de relacionados) en vez del de la PDP actual.
  const container = document.querySelector('[data-ff-charm-selector]:not(quick-add-modal [data-ff-charm-selector])')
  if (!container) return null

  // El charm selector vive en la PDP, fuera del modal. Emparejamos solo si el
  // producto del popup de tallas es la misma bag del selector: en la PDP hay
  // carruseles de relacionados que tambien abren quick-add y cogerian el charm ajeno.
  const modalProductId = variant.closest('product-info')?.dataset.productId
  if (!modalProductId || modalProductId !== container.dataset.ffBagProductId) return null

  const selected = Array.from(
    container.querySelectorAll('.ff-is-selected[data-ff-charm-variant-id]:not([data-ff-charm-variant-id=""])')
  )
  if (!selected.length) return null

  return {
    isMulti: container.hasAttribute('data-ff-multi-charm'),
    items: selected.map((charm) => ({
      id: parseInt(charm.dataset.ffCharmVariantId, 10),
      quantity: 1,
      properties: { [charm.dataset.dateProperty || 'Shipping Ready']: 1 }
    }))
  }
}

async function addToCartCustom(data) {
  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'X-Requested-With': 'XMLHttpRequest',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  })
  .then(response => {
    return response.json()
  })
  .then(json => {
    updateCartCustom();
  })
  .catch(error => {
    console.log(error)
  })
}

async function updateCartCustom() {
  fetch('/cart.js')
  .then(response => response.json())
  .then(cart => {
    updateCartDrawer();
    updateCartIcon(cart);
  })
}

function updateCartIcon(cart) {
  const cartIcon = document.getElementById('cart-icon-bubble')
  const elementToReplace = cartIcon.querySelector('.alohas-count-bubble')

  if(elementToReplace) {
    document.querySelector('.alohas-count-bubble span').textContent = '+' + cart.item_count
  } else {
    let numberContainer = document.createElement('div')
    numberContainer.classList.add('alohas-count-bubble')
    numberContainer.innerHTML = `<span>${cart.item_count}</span>`
    cartIcon.appendChild(numberContainer)
  }
}

function updateCartDrawer() {
  console.log('updating cart drawer')
  fetch(`${routes.cart_url}?sections=alohas-cart-drawer,alohas-cart-tag-data`)
  .then((response) => response.json())
  .then((sections) => {

    const html = new DOMParser().parseFromString(sections['alohas-cart-drawer'], 'text/html');

    const freshTagData = new DOMParser().parseFromString(sections['alohas-cart-tag-data'], 'text/html').querySelector('#CartTagData');
    const liveTagData = document.querySelector('#CartTagData');
    if (freshTagData && liveTagData) {
      liveTagData.innerHTML = freshTagData.innerHTML;
      if (typeof window.refreshCartItemsTagData === 'function') window.refreshCartItemsTagData();
    }
    const newSourceItems = html.querySelector('cart-drawer-items')
    const newPopupContent = html.querySelector('#cart_preorder_info .general--popup')

    if(document.querySelector('cart-drawer').classList.contains('is-empty')) {
      document.querySelector('.drawer__inner-empty').remove()
      document.querySelector('cart-drawer').classList.remove('is-empty')
    }

    document.querySelector('cart-drawer-items').replaceWith(newSourceItems);

    const cartFooter = document.querySelector('.cart-drawer__footer')
    const newSourceFooter = html.querySelector('.cart-drawer__footer')
    cartFooter.replaceWith(newSourceFooter);

    const cartShippingMessage = document.querySelector('.cart__drawer__free-shipping')
    const newSourceShippingMessage = html.querySelector('.cart__drawer__free-shipping')
    if(cartShippingMessage && newSourceShippingMessage) {
      cartShippingMessage.replaceWith(newSourceShippingMessage);
    }

    const preorderHtml = html.querySelector('.preorder-info-cart-container').innerHTML
    const currentPreorderContainer = document.querySelector('.preorder-info-cart-container')
      currentPreorderContainer.innerHTML = preorderHtml
      if (window.location.pathname.includes('/cart')) {
        currentPreorderContainer.setAttribute('data-popup-id', 'page-cart_preorder_info');
      }

    if (newPopupContent) {
      const currentPopup = document.querySelector('#cart_preorder_info .general--popup');
      if (currentPopup) {
        currentPopup.replaceWith(newPopupContent);
      }
    }

    initializeCartSwiper()
  })
}


function openCartDrawer() {
  document.querySelector('cart-drawer').classList.add('active');
}